import clsx from 'clsx';
import React from 'react';
import { InView } from 'react-intersection-observer';

import LazyImgixImage from '@components/LazyImgixImage';
import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, ImpressionElement, click, impression } from '@tracking';
import { getImgixSrc } from '@utils/images';

import { AWS_LOGO, AWS_TRACKING_LINK } from './constants';

interface PresentedByProps {
  hasBorder?: boolean;
}

const PresentedBy = ({ hasBorder }: PresentedByProps) => {
  const { trackEvent } = useEventTracking();

  return (
    <InView
      triggerOnce={true}
      onChange={(inView) => {
        inView && trackEvent(impression({ impressionElement: ImpressionElement.AWSLogo }));
      }}
    >
      <div
        className={clsx(
          'flex items-center gap-20',
          hasBorder &&
            'border-0 border-b border-solid border-grayscale-beige pb-20 sm:border-0 sm:border-b-0 sm:pb-0'
        )}
      >
        <span className="font-suisse-intl text-icon-sm">Presented By</span>
        <a
          className="block min-w-min"
          href={AWS_TRACKING_LINK}
          onClickCapture={() =>
            trackEvent(
              click({
                clickTarget: ClickTarget.Logo,
                clickText: AWS_LOGO,
              })
            )
          }
          rel="noreferrer sponsored"
          target="_blank"
        >
          <LazyImgixImage
            src={getImgixSrc({ path: 'titv/aws_logo_black.png', isEnvDependent: false })}
            alt={AWS_LOGO}
            className="mt-16 h-[34px] w-[57px]"
          />
        </a>
      </div>
    </InView>
  );
};

export default PresentedBy;
